import { createFileRoute } from "@tanstack/react-router";
import { buildRouteHead } from "@/lib/seo/routeHead";
import Solutions from "@/pages/Solutions";

export const Route = createFileRoute("/zh-cn/solutions/")({
  head: () => buildRouteHead("/zh-cn/solutions"),
  component: Solutions,
});

